<template>
	<div :style="{direction: $vs.rtl ? 'rtl' : 'ltr'}">
		<feather-icon
			icon="EditIcon"
			svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
			:title="$t('Edit')"
			@click="editRecord"
		/>
		<feather-icon
			v-if="uploadfileDeletePermission"
			icon="Trash2Icon"
			svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
			:title="$t('Crud.Delete')"
			@click="confirmDeleteRecord"
		/>
	</div>
</template>

<script>
export default {
	name: "CellRendererActions",
	data() {
		return {
			uploadFileListCopy: [],
			isRemove: true,
			timeoutCount: null,
			loading: true,
			percent: 0,
		};
	},
	computed: {
		uploadfileDeletePermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_D");
		},
		dataUploadFile() {
			return this.$store.state.uploadFile.uploadedFiles;
		},
	},
	methods: {
		editRecord() {
			this.$router.push("/apps/manual-data/" + this.params.data.id).catch(() => {});
		},
		confirmUndo() {
			this.uploadFileListCopy = [...this.dataUploadFile];
			this.$store.commit("uploadFile/ADD_ID_UPLOAD_FILES", this.params.data.id);
			this.$store.commit("uploadFile/REMOVE_UPLOAD_FILE_ITEM", this.params.data.id);
			this.$vs.notify({
				title: `${this.$t(
					"UploadFiles.TitleConfirmDelete"
				)} <a id="undoOperation" class="button-undo">${this.$t("Undo")}</a>`,
				text: `"${this.params.data.id}"`,
				color: "success",
				time: 10000,
			});
			let notifyActive = document.querySelector(".vs-notifications .content-noti .con-text-noti");
			notifyActive.insertAdjacentHTML(
				"beforeend",
				`
				<div
					class="vs-progress--background vs-progress-primary indeterminate" style="background: white; height: 6px;"
				>
					<div class="vs-progress--foreground" style="width: 0%;"></div>
					<div class="vs-progress--indeterminate" style="width: 0%;"></div>
				</div>`
			);
			document.getElementById("undoOperation").addEventListener("click", () => {
				this.isRemove = false;
				this.$store.commit("uploadFile/REMOVE_ID_UPLOAD_FILES", this.params.data.id);
				this.$store.commit("uploadFile/addUploadedFiles", []);
				this.$store.commit("uploadFile/addUploadedFiles", this.uploadFileListCopy);
			});
			this.timeoutCount = setTimeout(() => {
				if (this.isRemove) {
					this.deleteRecord();
				}
			}, 10000);
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text:
					this.$t("UploadFiles.DeleteUploadFile.Text1") +
					` "${this.params.data.id}"? ` +
					this.$t("UploadFiles.DeleteUploadFile.Text2"),
				accept: this.confirmUndo,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.$store
				.dispatch("uploadFile/removeUploadFile", this.params.data.id)
				.then((res) => {
					clearTimeout(this.timeoutCount);
					this.$store.commit("uploadFile/ADD_ID_UPLOAD_FILES", this.params.data.id);
					return res;
				})
				.catch((err) => {
					console.error(err);
					clearTimeout(this.timeoutCount);
				});
		},
	},
};
</script>
<style lang="scss">
.button-undo {
	border-bottom: 2px solid;
	color: rgb(92, 91, 91);
	margin-left: 5px;
	font-weight: bold;
	cursor: pointer;
	font-size: 14px;
}
</style>
